const ContextConfiguration = ({ rawAuthConfig, rawPluginConfig, rawPageConfig, assetPaths = null, }) => {
    let context = {};
    if (rawAuthConfig) {
        context.authContext = Object.assign({}, JSON.parse(rawAuthConfig));
    }
    if (rawPluginConfig) {
        context.pluginContext = Object.assign({}, JSON.parse(rawPluginConfig));
    }
    if (rawPageConfig) {
        context.pageContext = Object.assign({}, JSON.parse(rawPageConfig));
    }
    if (assetPaths) {
        context.assetPaths = Object.assign({}, JSON.parse(assetPaths));
    }
    return context;
};
export default ContextConfiguration;
